export default {
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  paginationTotal(state, value) {
    return (state.total = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  appraisalPeriods(state, value) {
    return (state.appraisalPeriods = value);
  },

  generalSettings(state, value) {
    return (state.generalSettings = value);
  },

  appraisalApprovalSettings(state, value) {
    return (state.appraisalApprovalSettings = value);
  },

  finalGradeSettings(state, value) {
    return (state.finalGradeSettings = value);
  },

  appraisalSettings(state, value) {
    return (state.appraisalSettings = value);
  },

  appraisalGroups(state, value) {
    return (state.appraisalGroups = value);
  },

  archivedAppraisalGroups(state, value) {
    return (state.archivedAppraisalGroups = value);
  },

  appraisalApproval(state, value) {
    return (state.appraisalApproval = value);
  },
  appraisalsAppraisalById(state, value) {
    return (state.appraisalsAppraisalById = value);
  },

  appraisalsAppraisal(state, value) {
    return (state.appraisalsAppraisal = value);
  },

  setSelectedRow(state, value) {
    return (state.selectedRow = value);
  },

  resetState(state) {
    state.currentPage = 1;
    state.perPage = 5;
    state.searchQuery = "";
    state.total = 0;
  },
};
